import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { store } from './store';

Vue.use(VueI18n)

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import es from 'vee-validate/dist/locale/es.json';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}
//
// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || 'en',
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: loadLocaleMessages()
// })

let veeValidateMessages = {
    en: {
        validation: en.messages
    },
    es: {
        validation: es.messages
    }
}

//const obj1 = messages;
const messages = loadLocaleMessages();
messages.en.validation = { ...messages.en.validation, ...veeValidateMessages.en.validation }
messages.es.validation = { ...messages.es.validation, ...veeValidateMessages.es.validation }


const i18n = new VueI18n({
    locale: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? 'es' : process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    formatFallbackMessages: true,
    messages: messages
});

export { i18n };
